import { SvgIcon } from "@mui/material";

// Custom data workspace icons used in navigation and tabs.

export const WeatherGenerationIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="17.2" cy="6.6" r="2.3" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M17.2 2.2v1.3M21.3 6.6H20M20 3.8l-.92.92M14.4 3.8l.92.92"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M13.7 15.8H7.1a3.15 3.15 0 0 1-.35-6.28 4.45 4.45 0 0 1 8.55 1.43 2.82 2.82 0 0 1-1.61 4.85z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M7 17.4h8.3l1.1 3.4H5.9L7 17.4zM8.1 19.1h1.7M11.2 19.1h1.7M14.3 19.1H16"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SunCloudIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="16.6" cy="7" r="2.5" fill="none" stroke="currentColor" strokeWidth="1.5" />
    <path
      d="M16.6 2.2v1.5M21.4 7h-1.5M20 3.6l-1.06 1.06M13.2 3.6l1.06 1.06M21.4 10.4l-1.3-.75"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.4"
      strokeLinecap="round"
    />
    <path
      d="M14.4 20.5H7.2a3.7 3.7 0 0 1-.55-7.36 4.9 4.9 0 0 1 9.53 1.3 3.05 3.05 0 0 1-1.78 6.06z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
  </SvgIcon>
);

export const SolarBoltIcon = (props) => (
  <SvgIcon {...props} viewBox="0 0 24 24">
    <circle cx="18" cy="6.2" r="2" fill="none" stroke="currentColor" strokeWidth="1.4" />
    <path
      d="M18 2.8v1M21.2 6.2h-1M20.3 4l-.72.72M15.7 4l.72.72"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.2"
      strokeLinecap="round"
    />
    <path
      d="M5.2 8h9.6l1.9 8.5H3.3L5.2 8z"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinejoin="round"
    />
    <path
      d="M4.4 12.25h11.2M10 8v8.5"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.1"
    />
    <path
      d="M10 16.5v2.6M6.8 21.1h6.4"
      fill="none"
      stroke="currentColor"
      strokeWidth="1.5"
      strokeLinecap="round"
    />
    <path d="M20.6 12l-3.1 4.6h1.9l-1.3 4.4 3.6-5.3h-1.9l1.6-3.7h-.8z" fill="currentColor" />
  </SvgIcon>
);
